import { useDispatch, useSelector } from "react-redux"
import { logActions } from "../../../../../store/log-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, logs } = props
    let selectedpagination = useSelector(state => state.log.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination == index ? 'active' : ''}`} onClick={() => {
        dispatch(logActions.setFilteredItems(logs))
        dispatch(logActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;